import { ComponentType, PropsWithChildren, ReactElement } from 'react';

export const withHigherOrderComponent =
  <TComponentProps,>(RootComponent: ComponentType<TComponentProps>) =>
  (
    NextComponent: ComponentType<TComponentProps>
  ): ComponentType<TComponentProps> => {
    return function WithHigherOrderComponent(
      props: PropsWithChildren<TComponentProps>
    ): ReactElement {
      const { children, ...rest } = props;

      return (
        <>
          <NextComponent {...(rest as TComponentProps)}>
            {children}
            <RootComponent {...(rest as TComponentProps)} />
          </NextComponent>
        </>
      );
    };
  };
